import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute=()=>{
    const userid = localStorage.getItem("userid");
     return userid ? <Outlet /> : <Navigate to="/" replace />;
};
export default ProtectedRoute;